import { APIModel } from './api-model.model'

export class APIBlacklist extends APIModel {
    blacklistId: number;
    blacklistMsisdn: string;
    blacklistExpireDate: string;
    carrierId: number;

    constructor (params: {
        id?: number;
        createdAt?: string;
        updatedAt?: string;
        deletedAt?: string;
        blacklistId: number;
        blacklistMsisdn: string;
        blacklistExpireDate: string;
        carrierId: number;
    }) {
        const { id, createdAt, updatedAt, deletedAt } = params
        super({ id, createdAt, updatedAt, deletedAt })

        this.blacklistId = params.blacklistId
        this.blacklistMsisdn = params.blacklistMsisdn
        this.blacklistExpireDate = params.blacklistExpireDate
        this.carrierId = params.carrierId
    }
}
